import { pipe } from 'fp-ts/function';
import { createAuthorizedGetRequest, decode, fetchApi, setQuery } from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';
import { listCodec } from '@/services/api/resources/activity/codec';
import { ActivityQuery, encodeActivityQuery } from '@/services/api/resources/activity/query';

export type LogType = 'checklists' | 'inspections';

export const listIssueActivities = (id: string, query: ActivityQuery) => pipe(
  `/v2/issues/${id}/activities`,
  createAuthorizedGetRequest,
  map(setQuery(encodeActivityQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const listActivities = (id: number, type: LogType, query: ActivityQuery) => pipe(
  `/v2/${type}/${id}/activities`,
  createAuthorizedGetRequest,
  map(setQuery(encodeActivityQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);
